import React from 'react'

import { Bold } from '../../../../packages/kiti/components/presentation/Text'
import { truncateString } from '../../../../utils/helpers/string'
import { useFieldValue } from '../../../../packages/kiti/components/form/form/FormHandler'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import Link from '../../../../packages/kiti/components/actions/Link'
import Select from '../../../../packages/kiti/components/form/Select'
import useTranslatedOrOriginalText from '../../../../utils/hooks/translate'

const EditableSentence = ({
  field,
  path,
  label,
  value: valueFromProps,
  onClick,
  Input: CustomInput,
  onChange,
  disableCloseOnChange,
  disableCloseOnBlur,
  truncate,
  showTooltip,
  ...props
}) => {
  const [isEditing, setIsEditing] = React.useState(false)
  const onClose = () => setIsEditing(false)
  const handleKeyUp = e => e.code === 'Escape' && onClose()
  const { getTranslatedOrOriginalText } = useTranslatedOrOriginalText(['triggers', 'common'])

  let [value, error] = useFieldValue({ field, path })
  value = valueFromProps || value

  CustomInput = CustomInput || Select

  const handleChange = v => {
    onChange(v)
    if (!disableCloseOnChange) onClose()
  }

  if (isEditing) {
    return (
      <CustomInput
        size="small"
        autoFocus
        onKeyUp={handleKeyUp}
        onBlur={!disableCloseOnBlur ? () => setTimeout(onClose, 200) : undefined}
        value={value}
        onChange={handleChange}
        disableEmptyOption
        onClose={onClose}
        {...props}
      />
    )
  }

  const handleClick = () => {
    return !!onClick ? onClick() : setIsEditing(true)
  }

  return (
    <Link onClick={handleClick}>
      <Bold size="h2" underline color={error && 'red'} title={label}>
        {truncateString(getTranslatedOrOriginalText('status.', label), truncate || 30)}
      </Bold>
      <Icon name="BsPencil" color={error ? 'red' : 'dark2'} size={1.2} />
    </Link>
  )
}

export default EditableSentence
